var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSchedule(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Uploaded to svgrepo.com",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.pictogram_een{fill:#F4D6B0;}\n\t.pictogram_twee{fill:#F8AD89;}\n\t.pictogram_vier{fill:#E54D2E;}\n\t.pictogram_vijf{fill:#01A59C;}\n\t.pictogram_zes{fill:#0C6667;}\n\t.st0{fill:#F27261;}\n\t.st1{fill:none;}\n\t.st2{clip-path:url(#SVGID_2_);fill:#F27261;}\n\t.st3{clip-path:url(#SVGID_2_);fill:none;}\n\t.st4{clip-path:url(#SVGID_6_);fill:#F4D6B0;}\n\t.st5{clip-path:url(#SVGID_8_);fill:#F27261;}\n\t.st6{clip-path:url(#SVGID_8_);fill:none;}\n\t.st7{clip-path:url(#SVGID_10_);fill:#F27261;}\n\t.st8{clip-path:url(#SVGID_10_);fill:none;}\n\t.st9{fill:#F4D6B0;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "pictogram_vijf",
    d: "M32,29c0,1.65-1.35,3-3,3H3c-1.65,0-3-1.35-3-3V3c0-1.65,1.35-3,3-3h26c1.65,0,3,1.35,3,3V29z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "pictogram_zes",
    d: "M3,0C1.35,0,0,1.35,0,3v26c0,1.65,1.35,3,3,3h13V0H3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "pictogram_een",
    d: "M3,26.2C3,27.194,3.806,28,4.8,28h22.4c0.994,0,1.8-0.806,1.8-1.8V10H3V26.2z M23,12h3v3h-3V12z  M23,17h3v3h-3V17z M23,22h3v3h-3V22z M17,12h3v3h-3V12z M17,17h3v3h-3V17z M17,22h3v3h-3V22z M11,12h3v3h-3V12z M11,17h3v3h-3V17z  M11,22h3v3h-3V22z M5,12h3v3H5V12z M5,17h3v3H5V17z M5,22h3v3H5V22z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "pictogram_een",
    d: "M29,5.8C29,4.806,28.194,4,27.2,4h-0.05C28.144,4,29,4.806,29,5.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "pictogram_twee",
    d: "M26,15h-3v-3h3V15z M20,12h-3v3h3V12z M14,12h-3v3h3V12z M8,12H5v3h3V12z M26,17h-3v3h3V17z M14,17 h-3v3h3V17z M8,17H5v3h3V17z M26,22h-3v3h3V22z M20,22h-3v3h3V22z M14,22h-3v3h3V22z M8,22H5v3h3V22z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "pictogram_vier",
    d: "M20,20h-3v-3h3V20z M27.15,4H4.8C3.806,4,3,4.806,3,5.8V10h26V5.8C29,4.806,28.144,4,27.15,4z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchedule);
export default __webpack_public_path__ + "static/media/schedule.f1cadd6cdbe6b21ea5df8ab9dc861a3f.svg";
export { ForwardRef as ReactComponent };